import axios from "axios";
import { buildP2PStats } from "./stats";
import { ALLOWED_FIATS, ALLOWED_SIDES, DEFAULT_P2P_LIMIT } from "./types";
import { formatRequestError } from "./errors";

const BINANCE_SEARCH = "/api/binance-p2p/bapi/c2c/v2/friendly/c2c/adv/search";

/**
 * Consulta preços P2P da Binance (lado do anúncio).
 * @param {Object} options
 * @param {"BRL"|"BOB"} options.fiat
 * @param {"BUY"|"SELL"} options.side
 * @param {number} [options.rows]
 * @param {string[]} [options.payTypes]
 * @returns {Promise<import("./types").P2PQuote>}
 */
export async function fetchBinanceP2P({
  fiat,
  side,
  rows = DEFAULT_P2P_LIMIT,
  payTypes = [],
}) {
  const normalizedFiat = String(fiat || "").toUpperCase();
  if (!ALLOWED_FIATS.includes(normalizedFiat)) {
    throw new Error("Fiat inválido para Binance P2P");
  }
  const normalizedSide = String(side || "").toUpperCase();
  if (!ALLOWED_SIDES.includes(normalizedSide)) {
    throw new Error("Side inválido para Binance P2P");
  }

  const payload = {
    asset: "USDT",
    fiat: normalizedFiat,
    tradeType: normalizedSide,
    page: 1,
    rows,
    publisherType: null,
  };
  const brlPayTypes = normalizedFiat === "BRL" ? (payTypes.length ? payTypes : ["PIX"]) : payTypes;
  if (Array.isArray(brlPayTypes) && brlPayTypes.length) {
    payload.payTypes = brlPayTypes;
  }

  // NOTE: produção precisa de proxy/servidor para contornar CORS; aqui usamos o proxy do Vite.
  let response;
  try {
    response = await axios.post(BINANCE_SEARCH, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    throw new Error(
      formatRequestError({
        exchange: "binance",
        fiat: normalizedFiat,
        side: normalizedSide,
        fallback: "Não foi possível obter anúncios válidos da Binance",
        error,
      })
    );
  }
  const list = Array.isArray(response.data?.data) ? response.data.data : [];
  const prices = list
    .map((item) => Number(item?.adv?.price))
    .filter((price) => Number.isFinite(price));
  if (!prices.length) {
    throw new Error("Não foi possível obter anúncios válidos da Binance");
  }
  return buildP2PStats({
    exchange: "binance",
    fiat: normalizedFiat,
    side: normalizedSide,
    prices,
    raw: import.meta.env.MODE === "development" ? list : undefined,
  });
}
